/**
 * La force d'une frappe, telle que le roll la dessine : un palier.
 *
 * Des paliers et non une valeur continue : l'épaisseur de la bande d'attaque
 * entre dans la clé du cache de géométries des notes (`note.ts`), et une
 * valeur par note y ferait une entrée par note.
 */

/** 0 : rien à dire, la note se dessine sans bande. 1 à 4 : de pp à ff. */
export type AttackLevel = 0 | 1 | 2 | 3 | 4;

/**
 * Les bornes des paliers, en vélocité MIDI sur 127 : sous 40 pp–p, puis mp,
 * mf, et f–ff à partir de 88.
 */
const LEVEL_BOUNDS = [40, 64, 88] as const;

/** Le palier d'une vélocité normalisée (0–1, soit la vélocité MIDI sur 127). */
export function attackLevel(velocity: number): Exclude<AttackLevel, 0> {
  const midi = Math.round(Math.min(1, Math.max(0, velocity)) * 127);

  if (midi < LEVEL_BOUNDS[0]) {
    return 1;
  }

  if (midi < LEVEL_BOUNDS[1]) {
    return 2;
  }

  if (midi < LEVEL_BOUNDS[2]) {
    return 3;
  }

  return 4;
}
